import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { auth, db } from './config';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { GlobalContext } from './Globalstate';

function Login() {
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [{ userdetails, loggedin }, dispatch] = useContext(GlobalContext);
  const [email, setemail] = useState('');
  const [password, setpassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // NEW STATE

  const handleSubmit = async () => {
    setloading(true);
    if (email !== '' && password !== '') {
      try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;

        if (user) {
          await fetchUserData(user.uid);
          setLoggedIn(true);
          navigate('/');
        }

        setloading(false);
      } catch (error) {
        console.error(error);
        alert(error.message);
        setloading(false);
      }
    } else {
      alert('Email or password is empty');
    }
  };

  const fetchUserData = async (userId) => {
    try {
      const docRef = doc(db, 'users', userId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setDetails(docSnap.data());
      } else {
        console.log('No such document!');
      }
    } catch (error) {
      console.error('Error getting document:', error);
    }
  };

  const setDetails = (data) => {
    dispatch({ type: 'setuserdetails', snippet: data });
  };

  const setLoggedIn = (data) => {
    dispatch({ type: 'setloggedin', snippet: data });
  };

  return (
    <div>
      <Helmet>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta httpEquiv="X-UA-Compatible" content="ie=edge" />
        <title>Investment Admin | Login</title>
        <link rel="icon" type="image/png" sizes="16x16" href="https://quorafund.com/img/in-logo%20-%20Copy%20(2).png" />
        <link rel="stylesheet" href="https://chainblockinvestment.com/public/plugins/fontawesome-free/css/all.min.css" />
        <link rel="stylesheet" href="https://chainblockinvestment.com/public/dashboard/includes/vendor/waves/waves.min.css" />
        <link id="current_style" rel="stylesheet" href="https://chainblockinvestment.com/public/dashboard/includes/css/style.css" />
      </Helmet>

      <div className="authentication" style={{ backgroundImage: 'url(https://chainblockinvestment.com/public/images/auth/auth-bg3.jpg)' }}>
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-xl-5 col-md-6">
              <div className="mini-logo text-center my-5">
                <a href="https://chainblockinvestment.com">
                  <img width={60} src="https://quorafund.com/img/in-logo%20-%20Copy%20(2).png" alt="" />
                </a>
              </div>
              <div className="auth-form card">
                <div className="card-header justify-content-center">
                  <h4 className="card-title">Sign in</h4>
                </div>
                <div className="card-body">
                  <form id="login_form">
                    <fieldset className="form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        className="form-control"
                        onChange={(e) => setemail(e.target.value)}
                      />
                    </fieldset>
                    <fieldset className="form-group">
                      <label>Password</label>
                      <div className="input-group">
                        <input
                          type={showPassword ? 'text' : 'password'}
                          className="form-control"
                          onChange={(e) => setpassword(e.target.value)}
                        />
                        <div className="input-group-append">
                          <button
                            type="button"
                            className="input-group-text"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            <i className={showPassword ? 'far fa-eye-slash' : 'far fa-eye'} />
                          </button>
                        </div>
                      </div>
                    </fieldset>
                    <div className="form-row d-flex justify-content-between mt-4 mb-2">
                      <div className="form-group mb-0">
                        <label className="toggle">
                          <input className="toggle-checkbox" type="checkbox" />
                          <span className="toggle-switch" />
                          <span className="toggle-label">Remember me</span>
                        </label>
                      </div>
                    </div>
                    <div className="text-center">
                      <button
                        type="button"
                        onClick={handleSubmit}
                        className="btn btn-success btn-block"
                        disabled={loading}
                      >
                        {loading ? 'Logging in...' : 'Log In'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
